import { useIsHydrated, useViewId, useViews } from '@/sdk';
import { useHookPermission } from '@/sdk/hooks/use-hook-permission';
import { horizontalListSortingStrategy } from '@/ui-lib/base/dnd-kit';
import { Skeleton, cn } from '@/ui-lib/shadcn';
import { DraggableWrapper } from './DraggableWrapper';
import { ViewListItem } from './ViewListItem';

export const ViewList = () => {
  const views = useViews();
  const activeViewId = useViewId();
  const isHydrated = useIsHydrated();
  const permission = useHookPermission();

  return isHydrated ? (
    views.length ? (
      <DraggableWrapper strategy={horizontalListSortingStrategy}>
        {({ setNodeRef, attributes, listeners, style, isDragging, view }) => (
          <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            style={style}
            className={cn('relative', {
              'opacity-50': isDragging,
            })}
          >
            <ViewListItem
              view={view}
              removable={!!permission['view|delete'] && views.length > 1}
              isActive={view.id === activeViewId}
            />
          </div>
        )}
      </DraggableWrapper>
    ) : (
      <Skeleton className="h-6 w-20" />
    )
  ) : (
    <>
      {views.map((view) => (
        <ViewListItem
          key={view.id}
          view={view}
          removable={!!permission['view|delete'] && views.length > 1}
          isActive={view.id === activeViewId}
        />
      ))}
    </>
  );
};
